// Updates the cart min-order remaining-amount label.
// Visibility of the alert container itself is owned by the Northbound
// runtime (it shows/hides `[data-northbound-cart-alert]`); we only set
// the "add $X more" copy on every pricing event.

(function () {
  function formatMoney(cents) {
    var normalized = Number.isFinite(cents) ? Math.round(cents) : 0;
    var runtime = window.__northboundStorefrontRuntime;
    var helpers = runtime && runtime.helpers;
    if (helpers && typeof helpers.formatMoney === 'function') {
      return helpers.formatMoney(normalized);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(normalized);
    }
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'CAD',
    }).format(normalized / 100);
  }

  function getMinimumCents() {
    var api = window.NorthboundStorefront;
    if (api && typeof api.getBootstrap === 'function') {
      try {
        var bootstrap = api.getBootstrap();
        if (bootstrap && Number.isFinite(bootstrap.minimumOrderCents)) {
          return bootstrap.minimumOrderCents;
        }
      } catch (err) {
        /* fall through */
      }
    }
    return 0;
  }

  function getProductSubtotalCents(node, result) {
    var cart = node.closest('[data-northbound-cart]') || document.querySelector('[data-northbound-cart]');
    var subtotalNode = cart && cart.querySelector('[data-northbound-cart-products-total]');
    var attrValue =
      subtotalNode && subtotalNode.getAttribute('data-northbound-base-subtotal-cents');
    if (attrValue !== null && attrValue !== '') {
      var attrCents = Number(attrValue);
      if (Number.isFinite(attrCents)) return attrCents;
    }

    var breakdown = result && result.landedBreakdown;
    var resultCents = breakdown && Number(breakdown.productSubtotalCents);
    return Number.isFinite(resultCents) ? resultCents : 0;
  }

  function applyAll(result) {
    var nodes = document.querySelectorAll('[data-northbound-cart-alert]');
    if (!nodes.length) return;

    var minimumCents = getMinimumCents();

    nodes.forEach(function (node) {
      var productSubtotalCents = getProductSubtotalCents(node, result);
      var remainingCents = Math.max(0, minimumCents - productSubtotalCents);
      var remainingWrap = node.querySelector('[data-cart-min-remaining]');
      var remainingAmount = node.querySelector('[data-cart-min-remaining-amount]');
      if (remainingAmount) {
        remainingAmount.textContent = formatMoney(remainingCents);
      }
      if (remainingWrap) {
        remainingWrap.hidden = remainingCents <= 0;
      }
    });
  }

  function getLatest() {
    var api = window.NorthboundStorefront;
    if (!api || typeof api.getCartPricingResult !== 'function') return null;
    try {
      return api.getCartPricingResult();
    } catch (err) {
      return null;
    }
  }

  function init() {
    applyAll(getLatest());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('northbound:cart-pricing-applied', function (event) {
    var result = event.detail && event.detail.cartPricingResult;
    applyAll(result);
  });

  window.addEventListener('northbound:community-changed', function () {
    applyAll(getLatest());
  });
})();
